import React from 'react';
import { Col } from 'react-bootstrap';
import { Button } from '@techem/ui-components';
import { KIND, SIZE } from 'baseui/button';

interface ButtonOrderProps {
  reverseOrder: boolean;
  onPrimaryClick: () => void;
  onSecondaryClick: () => void;
  primaryText: string;
  secondaryText: string;
}

const ButtonOrder: React.FC<ButtonOrderProps> = ({
  reverseOrder,
  onPrimaryClick,
  onSecondaryClick,
  primaryText,
  secondaryText
}) => {
  return reverseOrder ? (
    <>
      <Col xs={{ span: 12 }} lg={{ span: 'auto' }} className="d-flex mb-4">
        <div className="mx-auto">
          <Button onClick={onPrimaryClick} size={SIZE.large} additionalTestId="order-now-btn">
            {primaryText}
          </Button>
        </div>
      </Col>
      <Col xs={{ span: 12 }} lg={{ span: 'auto' }} className="d-flex mb-3">
        <div className="mx-auto">
          <Button kind={KIND.secondary} onClick={onSecondaryClick} size={SIZE.large}>
            {secondaryText}
          </Button>
        </div>
      </Col>
    </>
  ) : (
    <>
      <Col xs={{ span: 12 }} lg={{ span: 'auto' }} className="d-flex mb-3">
        <div className="mx-auto">
          <Button kind={KIND.secondary} onClick={onSecondaryClick} size={SIZE.large}>
            {secondaryText}
          </Button>
        </div>
      </Col>
      <Col xs={{ span: 12 }} lg={{ span: 'auto' }} className="d-flex mb-4">
        <div className="mx-auto">
          <Button onClick={onPrimaryClick} size={SIZE.large} additionalTestId="order-now-btn">
            {primaryText}
          </Button>
        </div>
      </Col>
    </>
  );
};

export default ButtonOrder;
